import { InAppMessageAction } from "../../../../core/internal/model/model"

export type InAppMessageEventType = "IMPRESSION" | "CLOSE" | "ACTION" | "IMAGE_IMPRESSION"

export abstract class InAppMessageViewEvent {
  protected constructor(readonly type: InAppMessageEventType, readonly timestamp: number) {}

  static impression(timestamp: number): InAppMessageImpressionViewEvent {
    return new InAppMessageImpressionViewEvent(timestamp)
  }

  static close(timestamp: number): InAppMessageCloseViewEvent {
    return new InAppMessageCloseViewEvent(timestamp)
  }

  static action(params: {
    timestamp: number
    action: InAppMessageAction
    area?: string
    buttonText?: string
    imageUrl?: string
    imageOrder?: number
    elementId?: string
  }): InAppMessageActionViewEvent {
    return new InAppMessageActionViewEvent(
      params.timestamp,
      params.action,
      params.area,
      params.buttonText,
      params.imageUrl,
      params.imageOrder,
      params.elementId
    )
  }

  static imageImpression(params: {
    timestamp: number
    imageUrl: string
    imageOrder: number
  }): InAppMessageImageImpressionViewEvent {
    return new InAppMessageImageImpressionViewEvent(params.timestamp, params.imageUrl, params.imageOrder)
  }
}

export class InAppMessageImpressionViewEvent extends InAppMessageViewEvent {
  constructor(timestamp: number) {
    super("IMPRESSION", timestamp)
  }
}

export class InAppMessageCloseViewEvent extends InAppMessageViewEvent {
  constructor(timestamp: number) {
    super("CLOSE", timestamp)
  }
}

export class InAppMessageActionViewEvent extends InAppMessageViewEvent {
  constructor(
    timestamp: number,
    readonly action: InAppMessageAction,
    readonly area?: string,
    readonly buttonText?: string,
    readonly imageUrl?: string,
    readonly imageOrder?: number,
    readonly elementId?: string
  ) {
    super("ACTION", timestamp)
  }
}

export class InAppMessageImageImpressionViewEvent extends InAppMessageViewEvent {
  constructor(timestamp: number, readonly imageUrl: string, readonly imageOrder: number) {
    super("IMAGE_IMPRESSION", timestamp)
  }
}
